import { API, SendRequest, axios } from '@/imports-files/components/model/communication-filter';
import { CommunicationFilterCandidateOptionsDummyData, CommunicationFilterGetCommunicationData, CommunicationFilterJobOptionsDummyData } from 'public/JSON_DATA/communication_center/communication_filter';

export class CommunicationFilterService extends SendRequest
{
    async get_communication_tab_data(params)
    {
        const url = API.client.activities.CUSTOM_INTEGRATIONS;
        try
        {
            const result = await axios.get(API.client.communication.COMMUNICATION_DATA,
            {
              params: params,
              headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
        } 
        catch (error) 
        {
        return error;
        }
    }


    async get_job_options()
    {
        // const url = API.client.communication.GET_JOB_OPTIONS;
        // try
        // {
        //     const result = await axios.get(url,
        //     {
        //       params: params,
        //       headers: this.customHeaderJSON()
        //     },
        //     this.setHeaderJSON(),
        //     this.setCrossDomainTrue(),
        //     this.setCredentialsJSON());
        // return result;
        // } 
        // catch (error) 
        // {
        // return error;
        // }

        return CommunicationFilterJobOptionsDummyData;
    }


    async get_candidate_job_options(params)
    {
        const url = API.client.communication.COMMUNICATION_DATA;
        try
        {
            const result = await axios.get(url,
            {
              params: params,
              headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
        } 
        catch (error) 
        {
        return error;
        }
    }
}